import { useTranslation } from '@/hooks/useTranslation';
import { useReveal } from '@/hooks/useReveal';
import aboutImg from '@/assets/about-team.png';

const AboutSection = () => {
  const { t } = useTranslation();
  useReveal();

  return (
    <section id="about">
      <div className="about-grid">
        <div className="about-visual rev-l">
          <div className="about-img-frame">
            <img src={aboutImg} alt="ADD Individual Solutions team" width={540} height={675} loading="lazy" decoding="async" style={{ width: '100%', aspectRatio: '4/5', objectFit: 'cover' }} />
          </div>
          <div className="about-accent-block">
            <span className="val">{t.about.accentVal}</span>
            <span className="lab" style={{ whiteSpace: 'pre-line' }}>{t.about.accentLabel}</span>
          </div>
          <div className="about-quote-block">
            <p>{t.about.quote}</p>
            <span className="attr">{t.about.quoteAttr}</span>
          </div>
        </div>

        <div className="about-text rev-r">
          <div className="section-tag">{t.about.tag}</div>
          <h2 className="section-h" style={{ whiteSpace: 'pre-line' }}>{t.about.title}</h2>
          <p>{t.about.story}</p>
          <p>{t.about.story2}</p>
          <div className="about-pillars">
            {t.about.pillars.map((p, i) => (
              <div className="pillar" key={i}>
                <div className="pillar-icon">{p.icon}</div>
                <h4>{p.title}</h4>
                <p>{p.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
